<template>
  <teleport to="body">
    <div
      ref="companyHolder"
      class="company-holder px-4 py-3 z-[9999] fixed bg-white/95 dark:bg-[#0d1a20]/95 backdrop-blur-xl border border-gray-300 dark:border-gray-700 text-gray-900 dark:text-gray-100 shadow-2xl rounded-xl transition-opacity duration-200"
      :class="isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'"
      :style="{
        width: width + 'px',
        visibility: isVisible ? 'visible' : 'hidden',
      }"
      :data-ref-id="refId"
      @mouseenter="mouseIsOver = true"
      @mouseleave="mouseIsOver = false"
    >
      <div v-if="loading" class="text-center py-6">
        <i class="text-2xl fas fa-circle-notch fa-spin text-blue-500"></i>
      </div>
      <div v-else-if="selectedPartner">
        <div class="flex items-center mb-3">
          <div class="shrink-0 mr-3">
            <img
              v-if="selectedPartner.logoUrl"
              :src="selectedPartner.logoUrl"
              class="h-10 w-10 object-contain rounded bg-white dark:bg-transparent p-1 border border-gray-200 dark:border-gray-700"
            />
            <div
              v-else
              class="h-10 w-10 bg-gray-100 dark:bg-gray-800 flex items-center justify-center rounded border border-gray-200 dark:border-gray-700"
            >
              <i
                class="fa-solid fa-building text-gray-400 dark:text-gray-500 text-lg"
              />
            </div>
          </div>
          <div class="overflow-hidden">
            <h3 class="font-bold text-sm leading-tight truncate">
              {{ selectedPartner.name }}
            </h3>
            <div
              v-if="selectedPartner.hqLocation"
              class="text-[10px] text-gray-500 dark:text-gray-400 truncate"
            >
              <i class="fas fa-map-marker-alt mr-1 opacity-60"></i>
              {{ selectedPartner.hqLocation }}
            </div>
          </div>
        </div>
        <div class="flex flex-wrap items-center gap-1.5 mb-3">
          <span
            v-if="selectedPartner.type_"
            class="bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 border border-blue-200 dark:border-blue-800/50 px-1.5 py-0.5 rounded text-[9px] font-bold uppercase tracking-wider"
          >
            {{ selectedPartner.type_ }}
          </span>
        </div>
        <div
          class="flex justify-end pt-2 border-t border-gray-100 dark:border-gray-800"
        >
          <a
            v-if="selectedPartner.validatedUrl"
            target="_blank"
            :href="selectedPartner.validatedUrl"
            class="text-blue-600 dark:text-blue-400 text-[10px] font-bold hover:underline flex items-center gap-1"
          >
            Visit Website <i class="fas fa-arrow-right text-[8px]"></i>
          </a>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import { createPopper } from "@popperjs/core";

export default {
  name: "ResearchCompassIndustryPartnerPopover",
  props: {
    question: Object,
    width: {
      type: Number,
      default: 240,
    },
  },
  emits: ["scroll-to-partner"],
  data() {
    return {
      isVisible: false,
      mouseIsOver: false,
      loading: true,
      refId: null,
      selectedPartner: null,
      popperInstance: null,
    };
  },
  watch: {
    mouseIsOver(newVal) {
      if (!newVal) {
        setTimeout(() => {
          if (!this.mouseIsOver) {
            this.hide();
          }
        }, 200);
      }
    },
  },
  methods: {
    show(targetRect) {
      this.isVisible = true;
      this.mouseIsOver = true;

      const virtualElement = {
        getBoundingClientRect: () => targetRect,
      };

      if (this.popperInstance) {
        this.popperInstance.destroy();
      }

      this.$nextTick(() => {
        if (!this.$refs.companyHolder) return;
        this.popperInstance = createPopper(
          virtualElement,
          this.$refs.companyHolder,
          {
            strategy: "fixed",
            placement: "top",
            modifiers: [
              {
                name: "offset",
                options: {
                  offset: [0, 2],
                },
              },
              {
                name: "flip",
                options: {
                  fallbackPlacements: ["bottom", "top"],
                },
              },
              {
                name: "preventOverflow",
                options: {
                  boundary: document.body,
                  padding: 16,
                },
              },
            ],
          },
        );
      });
    },
    hide() {
      this.isVisible = false;
      if (this.popperInstance) {
        this.popperInstance.destroy();
        this.popperInstance = null;
      }
    },
    hideIfNotHover() {
      if (!this.mouseIsOver) {
        this.hide();
      }
    },
    load() {
      this.loading = true;
      const nameToFind = this.refId
        ? decodeURIComponent(this.refId).toLowerCase()
        : "";
      this.selectedPartner = (this.question.industryPartners || []).find(
        (p) => p.name.toLowerCase() === nameToFind,
      );
      this.loading = false;
    },
  },
};
</script>
